import { PoliceManifestation } from "../Model/PoliceManifestation";
import { v4 as v4uuid } from "uuid";
import { getCurrentUser } from "./session";
export class PoliceManifestationService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOneByDiligenceNumber(ndiligencia, type) {
        if (ndiligencia) {
            const response = await this.apiService.get('policemanifestation/' + ndiligencia + '/' + type);
            if (response.status === 404) {
                return null;
            }
            if (!response.ok) {
                throw new Error(`Error al obtener la manifestacion policial`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener nDiligencia`);
        }
    }
    async savePoliceManifestation(policeManifestation) {
        if (policeManifestation) {
            const response = await this.apiService.post('policemanifestation', policeManifestation);
            if (!response.ok) {
                throw new Error(`Error al guardar la manifestación policial.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener la manifestación policial.`);
        }
    }
    async createPoliceManifestation(diligenceId, type) {
        if (diligenceId) {
            const policeManifestation = new PoliceManifestation({
                id: v4uuid(),
                diligenceNumber: diligenceId,
                type: type,
                manifestation: " ",
                dateCreated: new Date(),
                present: " ",
                delivery: " ",
                dateAppointment: new Date(),
                userId: getCurrentUser().id,
            });
            const response = await this.apiService.post('policemanifestation', policeManifestation.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciante de una diligencia trafico`);
            }
            return policeManifestation;
        }
        else {
            throw new Error(`Error al obtener el denunciante`);
        }
    }
}
